import { api } from "./api";
import type { FarmPnL, FlockEconomics } from "@/types/models";

export const economicsService = {
  // Farm-level P&L for a period. Empty from/to lets the backend default to the
  // current calendar month. The axios interceptor unwraps the {data} envelope.
  getFarmPnL: (from?: string, to?: string): Promise<FarmPnL> =>
    api
      .get<FarmPnL>("/economics/farm-pnl", {
        params: { ...(from ? { from } : {}), ...(to ? { to } : {}) },
      })
      .then((r) => r.data),

  // Per-flock cycle-to-date economics. Empty from/to → arrival → today.
  getFlockEconomics: (flockId: number, from?: string, to?: string): Promise<FlockEconomics> =>
    api
      .get<FlockEconomics>(`/flocks/${flockId}/economics`, {
        params: { ...(from ? { from } : {}), ...(to ? { to } : {}) },
      })
      .then((r) => r.data),

  // Cycle-to-date economics for every active flock — the comparison view.
  getFarmFlocksEconomics: (): Promise<FlockEconomics[]> =>
    api.get<{ flocks: FlockEconomics[] }>("/economics/flocks").then((r) => r.data.flocks),
};
